import { Injectable } from '@angular/core';
import {
  SuperHttpClientProvider,
  HttpCriteria
} from '@app/core/http';
import { Subject, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SensorService {
  sensorTypes = new ReplaySubject<any>();
  sensorTypesFixed: any;

  constructor(private $shttp: SuperHttpClientProvider) {}

  getSensorTypes() {
    return this.$shttp.default.get('/enum/sensorType');
  }

  //Obtener tipos de drenaje de sensor de humedad
  getSewerSystemTypes() {
    return this.$shttp.default.get('/enum/sewerSystemType');
  }

  getSensorSettings(idSensor: number) {
    const sensorSettingscriteria: HttpCriteria = new HttpCriteria({
      _filters: [
        {
          field: 'idSensor',
          operator: '=',
          value: idSensor
        }
      ],
      _sort: [
        {
          field: 'instant',
          type: 'ASC'
        }
      ],
      _perPage: -1
    });
    return this.$shttp.default.filter(
      '/admin/settings',
      sensorSettingscriteria
    );
  }

  createSensorSetting(sensorSetting: any) {
    return this.$shttp.default.post('/admin/settings', sensorSetting);
  }

  updateSensorSetting(idSetting: number, sensorSetting: any[]) {
    console.log('##########', sensorSetting);
    return this.$shttp.default.put(
      `/admin/settings/${idSetting}`,
      sensorSetting
    );
  }

  deleteSensorSetting(idSetting: number) {
    return this.$shttp.default.delete('/admin/settings/' + idSetting);
  }
}
